import React from "react";
import {
  Box,
  Center,
  Text,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";

export const Footer = (props) => {
  const page = props.page;
  let navigate = useNavigate();

  return (
    <GridItem area={"footer"}>
      <Box
        bottom="0px"
        position="absolute"
        p="30px"
        width="100%"
        bg={useColorModeValue("gray.600", "gray.600")}
        color={useColorModeValue("gray.100", "gray.100")}
      >
        <Center>
          <Text>Copyright © {new Date().getFullYear()} Hubit</Text>
        </Center>
      </Box>
    </GridItem>
  );
};
